export default [ '#00A59C', '#FFBE45', '#A31DB5', '#FC6F73', '#4053D0', '#98AB2B', '#7E4925' ];

// 00A59C-FFBE45-A31DB5-FC6F73-4053D0